module.exports = __webpack_public_path__ + "static/media/preview_general_campaign_2.d35f17a3.svg";